import PropTypes from "prop-types";

const Pill = (props) => {

	const {
		className, onClick, selected, id,
		labelFontClass, data, disabled,
	} = props;
	const classNames = className ? ` ${className}` : "";
	const handleClick = (value) => {

		if (typeof onClick === "function" && !selected) {

			onClick(value);

		}

	};
	return (
		<>
			<button
				id={id}
				type="button"
				className={`pill ${labelFontClass}${classNames}${
					selected ? " pill-selected" : ""
				}`}
				onClick={handleClick.bind(null, data.value)}
				disabled={disabled}
			>
				<span>
					{data.label}
				</span>
			</button>

			<style>
				{`
					.pill {
						padding: 6px 16px;
						border-radius: 16px;
						border: 1px solid #DFE3E8;
						cursor:pointer;
						height: fit-content;
						width: fit-content;
						color: #919EAB;
						background-color: white;
						transition: all 0.2s ease-in-out;
						white-space: nowrap;

						&:not(:disabled):hover {
						color: #DB284E;
						border: 1px solid #DB284E;
						font-family: 'Creato Display';
						}

						&:not(:disabled):active {
						color:#DB284E;
						box-shadow: 0px 4px 4px 6px rgba(0, 0, 0, 0.1) inset;
						}

						&:disabled {
						color: #DFE3E8;
						cursor: not-allowed;
						}
					}
					.pill > span {
						font-size: 14px !important;
						font-family: 'Creato Display';
					}
					.pill-selected {
						background-color:#FCEFF2 !important;
						border-color: #DB284E !important;
						color: #DB284E !important;
						box-shadow: none !important;
					}
				`}
			</style>
		</>
	);

};

Pill.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	data: PropTypes.shape({
		id: PropTypes.string,
		label: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		labelFontClass: PropTypes.string,
		disabled: PropTypes.bool,
	}),
	onClick: PropTypes.func,
	labelFontClass: PropTypes.string,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
};

Pill.defaultProps = {
	id: null,
	className: "",
	labelFontClass: "fd-body-md-regular",
	selected: false,
	disabled: false,
	data: null,
	onClick: null,
};

export default Pill;
